/**
*  料金シミュレーター
*
*  短期入所 & 短期入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_short = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  income : [ 1750, 300, 600, 1000, 1300 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 520, 0, 370, 370, 370 ],
    //two  : [ 0, 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 3170, 1810, 1810, 2630, 2630 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1449, 2528, 3607 ],
        //two  : [ 0, 0, 0 ]
      },
      single : [ 1358, 2347, 3336 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1534, 2698, 3862 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1440, 2510, 3580 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1604, 2838, 4073 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1510, 2651, 3791 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1667, 2965, 4263 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1575, 2780, 3986 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1732, 3095, 4458 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1637, 2905, 4173 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1207, 2044, 2881 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1163, 1957, 2750 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1384, 2398, 3413 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1323, 2276, 3229 ]
    }
  ]
}

//短期入所（認知棟）
const array_shortSub = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  income : [ 1750, 300, 600, 1000, 1300 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 520, 0, 370, 370, 370 ],
    //two  : [ 0, 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 1850, 490, 490, 1310, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1534, 2698, 3862 ],
        //two  : [ 0, 0, 0 ]
      },
      single : [ 1443, 2517, 3590 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1618, 2867, 4116 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1525, 2680, 3835 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1689, 3008, 4327 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1595, 2820, 4046 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1752, 3135, 4518 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1660, 2950, 4240 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1817, 3265, 4712 ],
          //two  : [ 0, 0, 0 ]
        },
      single : [ 1722, 3075, 4427 ]
    },
    // { // 要支援 1 : [ 1割, 2割, 3割 ]
    //   multi  : {
    //       four : [ 0, 0, 0 ],
    //       two  : [ 0, 0, 0 ]
    //     },
    //   single : [ 0, 0, 0 ]
    // },
    // { // 要支援 2 : [ 1割, 2割, 3割 ]
    //   multi  : {
    //       four : [ 0, 0, 0 ],
    //       two  : [ 0, 0, 0 ]
    //     },
    //   single : [ 0, 0, 0 ]
    // }
  ]
}





/**
*  function
*  動作
*/

// 短期入所
$( calcBtn.shortStay ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStay ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStay, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_short.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_short.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_short.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_short.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStay ).html( numberWithComma.format( result ) );
    $( resultElm.shortStayDays ).html( selectVal.days );
  } // end of 計算処理開始
return;
});



// 短期入所（認知棟）
$( calcBtn.shortStaySub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStaySub ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStaySub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_shortSub.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_shortSub.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_shortSub.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_shortSub.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStaySub ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始

return;

});
